import { PostModel } from '../data-layer/posts/types';

export const hasAvailableProducts = (postModel: PostModel) =>
    postModel.products?.items?.some((item) => !item.isUnavailable);
